import React, { useState, useEffect } from 'react';
import { OITTexts } from '../contexts/LangOIT';
import ProductOITOutline from './ProductOIT-outline';
import ProductOITSpecial from './ProductOIT-special';
import ProductOITFunction from './ProductOIT-function';

function ProductOIT({ lang = 'ko' }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#29225C', // 바탕색을 #29225C로 변경
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <h1 style={{
        color: '#fff',
        fontSize: isMobile ? '1.8rem' : '2.5rem',
        fontWeight: 700,
        letterSpacing: '-1px',
        margin: 0,
        marginBottom: isMobile ? 20 : 40,
        textAlign: 'center',
        padding: isMobile ? '0 20px' : '0'
      }}>
        <br /><br /><br />{OITTexts.title[lang]}
        <br /><span style={{ color: '#ffb300' }}>{OITTexts.subtitle[lang]}</span>
      </h1>
      <ProductOITOutline lang={lang} isMobile={isMobile} />
      <ProductOITSpecial lang={lang} isMobile={isMobile} />
      <ProductOITFunction lang={lang} isMobile={isMobile} />
    </div>
  );
}

export default ProductOIT;